import { render, staticRenderFns } from "./sortgroup.vue?vue&type=template&id=698bf548"
import script from "./sortgroup.vue?vue&type=script&lang=tsx"
export * from "./sortgroup.vue?vue&type=script&lang=tsx"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports